import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box'
import { Typography } from '@mui/material'
import ActivityChart from '@/components/charts/ActivityChart'
import AppointmentSet from '@/components/charts/AppointmentSet'
import { getValueChangeTextColor } from '@/utils/helper'
import SouthEastIcon from '@mui/icons-material/SouthEast'
import NorthEastIcon from '@mui/icons-material/NorthEast'
import DataAlert from '@/components/common/CustomTooltip/DataAlert'
import CustomTooltip from '@/components/common/CustomTooltip'
import { CurrentActivityState } from '@/types/current_activity'

interface IscActivityProps {
  data: CurrentActivityState
  activityTimeframe: string
}

const IscActivity = ({ data, activityTimeframe }: IscActivityProps) => {
  return (
    <Box>
      <Stack direction="row" gap={2} mb={6}>
        <Stack sx={{ width: 160 }}>
          <CustomTooltip elementName="label-activity-calls">
            <Typography
              variant="body1"
              fontWeight={700}
              mb={-1.5}
              color="rgba(255, 255, 255, 0.67)"
            >
              <DataAlert elementName="label-activity-calls">Calls</DataAlert>
            </Typography>
          </CustomTooltip>
          <Stack direction="row" alignItems="flex-end" spacing={1}>
            <Typography variant="h1">{(data?.TOTAL_CALLS || 0).toLocaleString()}</Typography>
            <Stack sx={{ pb: 0.75 }}>
              {(data?.TOTAL_CALLS_PERCENT_CHANGE || 0) !== 0 &&
                ((data?.TOTAL_CALLS_PERCENT_CHANGE || 0) > 0 ? (
                  <NorthEastIcon color="success" />
                ) : (
                  <SouthEastIcon color="error" />
                ))}
              <CustomTooltip elementName="value-percent-change">
                <Typography
                  component="span"
                  color={getValueChangeTextColor(data?.TOTAL_CALLS_PERCENT_CHANGE || 0)}
                  variant="h6"
                  sx={{ ml: 1 }}
                >
                  {data?.TOTAL_CALLS_PERCENT_CHANGE || 0}%
                </Typography>
              </CustomTooltip>
            </Stack>
          </Stack>
        </Stack>
        {data?.CALLS_TICKER_ARRAY && <ActivityChart data={data?.CALLS_TICKER_ARRAY || []} />}
      </Stack>
      <Stack direction="row" gap={2} mb={6}>
        <Stack sx={{ width: 160 }}>
          <CustomTooltip elementName="label-activity-chat-text">
            <Typography
              variant="body1"
              fontWeight={700}
              mb={-1.5}
              color="rgba(255, 255, 255, 0.67)"
            >
              <DataAlert elementName="label-activity-chat-text" truncateSize={10}>
                Chats and texts
              </DataAlert>
            </Typography>
          </CustomTooltip>
          <Stack direction="row" alignItems="flex-end" spacing={1}>
            <Typography variant="h1">{(data?.TOTAL_CHATS_TEXTS || 0).toLocaleString()}</Typography>
            <Stack sx={{ pb: 0.75 }}>
              {(data?.TOTAL_CHATS_TEXTS_PERCENT_CHANGE || 0) !== 0 &&
                ((data?.TOTAL_CHATS_TEXTS_PERCENT_CHANGE || 0) > 0 ? (
                  <NorthEastIcon color="success" />
                ) : (
                  <SouthEastIcon color="error" />
                ))}
              <CustomTooltip elementName="value-percent-change">
                <Typography
                  component="span"
                  color={getValueChangeTextColor(data?.TOTAL_CHATS_TEXTS_PERCENT_CHANGE || 0)}
                  variant="h6"
                  sx={{ ml: 1 }}
                >
                  {data?.TOTAL_CHATS_TEXTS_PERCENT_CHANGE || 0}%
                </Typography>
              </CustomTooltip>
            </Stack>
          </Stack>
        </Stack>
        {data?.CHATS_TEXTS_TICKER_ARRAY && (
          <ActivityChart data={data?.CHATS_TEXTS_TICKER_ARRAY || []} />
        )}
      </Stack>
      <Stack direction="row" alignItems="flex-end" gap={2} mb={6}>
        <Stack sx={{ width: 160 }}>
          <CustomTooltip elementName="label-activity-appointment-set">
            <Typography
              variant="body1"
              fontWeight={700}
              mb={-1.5}
              color="rgba(255, 255, 255, 0.67)"
            >
              <DataAlert elementName="label-activity-appointment-set" truncateSize={10}>
                Appointments set
              </DataAlert>
            </Typography>
          </CustomTooltip>
          <Stack direction="row" alignItems="flex-end" spacing={1}>
            <Typography variant="h1">{(data?.APPOINTMENTS_SET || 0).toLocaleString()}</Typography>
            <Stack sx={{ pb: 0.75 }}>
              {(data?.APPOINTMENTS_SET_PERCENT_CHANGE || 0) !== 0 &&
                ((data?.APPOINTMENTS_SET_PERCENT_CHANGE || 0) > 0 ? (
                  <NorthEastIcon color="success" />
                ) : (
                  <SouthEastIcon color="error" />
                ))}
              <CustomTooltip elementName="value-percent-change">
                <Typography
                  component="span"
                  color={getValueChangeTextColor(data?.APPOINTMENTS_SET_PERCENT_CHANGE || 0)}
                  variant="h6"
                  sx={{ ml: 1 }}
                >
                  {data?.APPOINTMENTS_SET_PERCENT_CHANGE || 0}%
                </Typography>
              </CustomTooltip>
            </Stack>
          </Stack>
        </Stack>
        <AppointmentSet
          currentWeekData={data?.APPOINTMENT_SET_TICKER_ARRAY || []}
          prevWeekData={data?.PRIOR_WEEK_APPOINTMENT_SET_TICKER_ARRAY || []}
          activityTimeframe={activityTimeframe}
        />
      </Stack>
    </Box>
  )
}

export default IscActivity
